export default __webpack_public_path__ + "images/Svay-Sach-Phnum-golden-adorned-column-painting.webp";